import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Request-builder chrome the user turns on and expects to STAY on.
 *
 * `variablesPanelOpen` used to be `useState(false)` inside RequestBuilder, so
 * every unmount — switching to Chat, Docs, Boards, or just to another page and
 * back — silently closed the variables panel. That is the bug the owner
 * reported ("if user turned it on it should stay on").
 *
 * Deliberately GLOBAL, not per request: the panel is a workbench affordance
 * ("show me what the variables resolve to while I edit"), not a property of one
 * request. Making it per-request re-creates the same surprise one request later.
 *
 * Deliberately PERSISTED to plain localStorage, device-global:
 *  - it survives an app restart, which is what "stay on" means for a preference;
 *  - it is a display toggle, not a credential and not user data, so it does NOT
 *    need `accountScopedStorage` the way certificateStore does;
 *  - it lives in its own key rather than in `apiboo-app-preferences`, so it does
 *    not entangle with the app-preferences modules (and cannot corrupt them if
 *    this key is ever hand-edited or dropped).
 *
 * Keep this store small. It is the request builder's UI chrome, nothing else.
 */
export const useRequestUiStore = create(
  persist(
    (set) => ({
      variablesPanelOpen: false,
      setVariablesPanelOpen: (variablesPanelOpen) => set({ variablesPanelOpen: !!variablesPanelOpen }),
      toggleVariablesPanel: () => set((s) => ({ variablesPanelOpen: !s.variablesPanelOpen })),
    }),
    {
      name: 'apiboo-request-ui',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ variablesPanelOpen: state.variablesPanelOpen }),
    }
  )
);
